"use client";

import * as React from "react";

// @components
import {
  Button,
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from "@/components";

// @icons
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/24/outline";

// @hooks
import { useVariation } from "../store";
import type { VariationFilter } from "@/lib/liquidity-filter";

const VARIATION_LABELS: Record<VariationFilter, string> = {
  EHEX: "eHEX",
  PHEX: "pHEX",
  "EHEX & PHEX": "eHEX & pHEX",
};

export function Variation() {
  const variation = useVariation((state) => state.variation);
  const setToPHEX = useVariation((state) => state.setToPHEX);
  const setToEHEX = useVariation((state) => state.setToEHEX);
  const setToBoth = useVariation((state) => state.setToBoth);

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        asChild
        aria-label="Variation Selector"
        className="group outline-none focus-visible:outline-none"
      >
        <Button
          variant="simple"
          contentClassName="!px-4 !py-3 flex items-center gap-3"
        >
          {VARIATION_LABELS[variation]}
          <ChevronDownIcon className="h-4 w-4 stroke-2 transition-transform duration-200 group-data-[state=open]:rotate-180" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-40">
        <DropdownMenuItem onClick={setToEHEX}>
          <span className="mr-4">eHEX</span>
          <span className="text-2xs text-muted">Ethereum + bridged</span>
          {variation === "EHEX" && (
            <CheckIcon className="ml-auto h-4 w-4 stroke-2" />
          )}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={setToPHEX}>
          <span className="mr-4">pHEX</span>
          <span className="text-2xs text-muted">PulseChain</span>
          {variation === "PHEX" && (
            <CheckIcon className="ml-auto h-4 w-4 stroke-2" />
          )}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={setToBoth}>
          <span className="mr-4">eHEX & pHEX</span>
          {variation === "EHEX & PHEX" && (
            <CheckIcon className="ml-auto h-4 w-4 stroke-2" />
          )}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
